// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card_i9TI1","top":"Card_top_3Glqs","top_title":"Card_top_title_2VrQk","top_actions":"Card_top_actions_yXn1L"};